var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrushBuilder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22C10.7 22 10.2292 21.8042 9.8375 21.4125C9.44583 21.0208 9.25 20.55 9.25 20V16H6.25C5.7 16 5.22917 15.8042 4.8375 15.4125C4.44583 15.0208 4.25 14.55 4.25 14V7C4.25 5.9 4.64167 4.95833 5.425 4.175C6.20833 3.39167 7.15 3 8.25 3H20.25V14C20.25 14.55 20.0542 15.0208 19.6625 15.4125C19.2708 15.8042 18.8 16 18.25 16H15.25V20C15.25 20.55 15.0542 21.0208 14.6625 21.4125C14.2708 21.8042 13.8 22 13.25 22H11.25ZM6.25 10H18.25V5H17.25V9H15.25V5H14.25V7H12.25V5H8.25C7.7 5 7.22917 5.19583 6.8375 5.5875C6.44583 5.97917 6.25 6.45 6.25 7V10ZM6.25 14H18.25V12H6.25V14Z",
    fill: "#773CEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22C10.7 22 10.2292 21.8042 9.8375 21.4125C9.44583 21.0208 9.25 20.55 9.25 20V16H6.25C5.7 16 5.22917 15.8042 4.8375 15.4125C4.44583 15.0208 4.25 14.55 4.25 14V7C4.25 5.9 4.64167 4.95833 5.425 4.175C6.20833 3.39167 7.15 3 8.25 3H20.25V14C20.25 14.55 20.0542 15.0208 19.6625 15.4125C19.2708 15.8042 18.8 16 18.25 16H15.25V20C15.25 20.55 15.0542 21.0208 14.6625 21.4125C14.2708 21.8042 13.8 22 13.25 22H11.25ZM6.25 10H18.25V5H17.25V9H15.25V5H14.25V7H12.25V5H8.25C7.7 5 7.22917 5.19583 6.8375 5.5875C6.44583 5.97917 6.25 6.45 6.25 7V10ZM6.25 14H18.25V12H6.25V14Z",
    fill: "url(#paint0_linear_2796_27242)",
    fillOpacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2796_27242",
    x1: 12.25,
    y1: 3,
    x2: 12.25,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E467B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrushBuilder);
export default __webpack_public_path__ + "e9f087ab8f0105aceece6f924b55ed43.svg";
export { ForwardRef as ReactComponent };